












































































































































import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import Form from '@/mixins/form'
import {
  VitalsignSetting,
  VitalsignSettingNullable,
  VitalsignSettingChk
} from '@/types/vitalsign'
import ky from 'ky'

const settingKeys = {
  emgIsLimitchkSbp: ['emgLimitSbpLow', 'emgLimitSbpHigh'],
  emgIsLimitchkDbp: ['emgLimitDbpLow', 'emgLimitDbpHigh'],
  emgIsLimitchkHeartRate: ['emgLimitHeartRateLow', 'emgLimitHeartRateHigh'],
  emgIsLimitchkTemperature: [
    'emgLimitTemperatureLow',
    'emgLimitTemperatureHigh'
  ],
  emgIsLimitchkWeight: ['emgLimitWeightLow', 'emgLimitWeightHigh'],
  emgIsLimitchkSpo2: ['emgLimitSpo2Low', 'emgLimitSpo2High'],
  emgIsLimitchkGlucose: ['emgLimitGlucoseLow', 'emgLimitGlucoseHigh'],
  emgIsLimitchkPulseRate: ['emgLimitPulseRateLow', 'emgLimitPulseRateHigh'],
  warnIsLimitchkSbp: ['warnLimitSbpLow', 'warnLimitSbpHigh'],
  warnIsLimitchkDbp: ['warnLimitDbpLow', 'warnLimitDbpHigh'],
  warnIsLimitchkHeartRate: ['warnLimitHeartRateLow', 'warnLimitHeartRateHigh'],
  warnIsLimitchkTemperature: [
    'warnLimitTemperatureLow',
    'warnLimitTemperatureHigh'
  ],
  warnIsLimitchkWeight: ['warnLimitWeightLow', 'warnLimitWeightHigh'],
  warnIsLimitchkSpo2: ['warnLimitSpo2Low', 'warnLimitSpo2High'],
  warnIsLimitchkGlucose: ['warnLimitGlucoseLow', 'warnLimitGlucoseHigh'],
  warnIsLimitchkPulseRate: ['warnLimitPulseRateLow', 'warnLimitPulseRateHigh']
}

@Component({
  components: {
    TextInput: () => import('@/components/common/inputs/TextInput.vue')
  }
})
export default class VitalsignSettings extends mixins(Form) {
  @Prop(Number) patientId!: number
  settings: Partial<VitalsignSetting> = {}
  settingLabels = [
    {
      label: 'SpO2',
      unit: '測定値',
      prop: 'Spo2'
    },
    {
      label: '収縮期血圧',
      unit: '測定値( mmHg )',
      prop: 'Sbp'
    },
    {
      label: '拡張期血圧',
      unit: '測定値( mmHg )',
      prop: 'Dbp'
    },
    {
      label: '脈拍数',
      unit: '測定値',
      prop: 'PulseRate'
    },
    {
      label: '心拍数',
      unit: '測定値( bpm )',
      prop: 'HeartRate'
    },
    {
      label: '体温',
      unit: '測定値( ℃ )',
      prop: 'Temperature'
    },
    {
      label: '体重',
      unit: '測定値( kg )',
      prop: 'Weight'
    },
    {
      label: '血糖値',
      unit: '測定値',
      prop: 'Glucose'
    }
  ]

  @Emit('close')
  onClose() {
    return
  }

  get errors() {
    return this.validator.messages
  }

  async created() {
    const res = await this.$api.vitalsign.fetchSetting({
      patientId: this.patientId
    })
    console.log(res)
    this.settings = res
  }

  mounted() {
    this.checkError()
  }

  async save() {
    if (this.validator.hasAnyError()) {
      return
    }
    const payload = { ...this.settings }
    Object.entries(payload).forEach(([key, data]) => {
      const k = key as keyof VitalsignSetting
      if (Object.keys(settingKeys).includes(k) && !payload[k]) {
        const keys = settingKeys[k as keyof VitalsignSettingChk]
        const low = payload[keys[0] as keyof VitalsignSettingNullable] as any
        const high = payload[keys[1] as keyof VitalsignSettingNullable] as any
        if (low === '') {
          payload[keys[0] as keyof VitalsignSettingNullable] = null
        }
        if (high === '') {
          payload[keys[1] as keyof VitalsignSettingNullable] = null
        }
      }
    })
    try {
      await this.$api.vitalsign.putSetting({
        patientId: this.patientId,
        payload: payload
      })
      localStorage.setItem('message', '保存されました')
    } catch (e) {
      if (e instanceof ky.HTTPError) {
        const errors = await e.response.json()
        this.$store.dispatch('alert/showErrorResponse', errors)
        return
      }
    }

    this.onClose()
  }

  checkError() {
    this.validator.hasAnyError()
  }
}
